// extracted by mini-css-extract-plugin
export default {"container":"checkbox_container__Q-5VR","disabled":"checkbox_disabled__LvZh3","input":"checkbox_input__idJ9t","label":"checkbox_label__wk+UH"};